
import { AverageImpressionGreyIcon, AverageImpressionYellowIcon, BadImpressionGreyIcon, BadImpressionYellowIcon, GoodImpressionGreyIcon, GoodImpressionYellowIcon, PerfectImpressionGreyIcon, PerfectImpressionYellowIcon, TerribleImpressionGreyIcon, TerribleImpressionYellowIcon } from "../../assets/images";
import { TableHeadersType } from "../../constant/tableHeadersConstants/tableHeadersType";
import { AverageJobRatingListDataType } from "../../redux/mySpace/mySpaceTypes";
import { formatDate } from "../../utils/commonFunctions";
import { CircularAvatar } from "../commons";

type AppProps = {
  data: AverageJobRatingListDataType[] | [];
  tableHeader: TableHeadersType[];

};
const AllUserRatingTableData = ({
  data,
  tableHeader,
}: AppProps) => {
  return (
    <>
      {data &&
        data?.length > 0 &&
        data?.map((itemData: any) => {
          return (
            <tr key={itemData?._id}>
              {tableHeader?.map((item: TableHeadersType) => {
                    if (item?.value == "job_type") {
                        return (
                          <td className="text-left">
                            {`${itemData?.job_id}_${
                              itemData?.job_type
                                ? itemData?.job_type
                                : ""
                            }_${
                                itemData?.period_ended
                                ? formatDate(itemData?.period_ended)
                                : ""
                            }`}
                          </td>
                        );
                      } else if (item?.value == "job_description") {
                        return (
                          <td
                            className="text-left"
                            style={{ minWidth: "230px" }}
                          >
                            {itemData?.job_description}
                          </td>
                        );
                      } else if (item?.value == "company_name") {
                        return (
                          <td className="text-left">
                            {`${itemData?.client_details?.company_name} (${itemData?.client_details?.client_code})`}
                          </td>
                        );
                      } else if (item?.value == "job_manager") {
                        return (
                          <td
                            className="text-left"
                            style={{ minWidth: "170px" }}
                          >
                            <div
                              className="ml-2"
                              style={{
                                display: "flex",
                                justifyContent: "left",
                                alignItems: "center",
                                gap: "7px",
                              }}
                            >
                              <CircularAvatar
                                name={`${itemData?.job_manager?.first_name} ${itemData?.job_manager?.last_name}`}
                                image={
                                    itemData?.job_manager
                                    ?.profile_pic &&
                                    itemData?.job_manager?.profile_pic
                                    ?.file_url
                                }
                              />
                              <div>
                                {`${itemData?.job_manager?.first_name} ${itemData?.job_manager?.last_name} `}
                              </div>
                            </div>
                            {/* <br></br> */}
                            <p
                              style={{
                                color: "#6e7491",
                                fontSize: "12px",
                                marginLeft: "33px",
                                marginBottom: "0px",
                              }}
                            >
                              {`${itemData?.job_manager?.job_title}`}
                            </p>
                            <p
                              style={{
                                color: "#6e7491",
                                fontSize: "12px",
                                marginLeft: "33px",
                              }}
                            >
                              {itemData?.job_manager?.department}
                            </p>
                          </td>
                        );
                      } else if (item?.value == "job_status") {
                        return (
                          <td className="text-left">
                            {itemData?.job_status === "Open" ? (
                              <span className="Open">
                                {itemData?.job_status}
                              </span>
                            ) : (
                              <span className="Close">
                                {itemData?.job_status}
                              </span>
                            )}
                          </td>
                        );
                      } else if (item?.value == "rating") {
                        return (
                          <td className="text-left">
                              <div className="d-flex g-2">
                                  <div className=" mr-3">
                                    <img
                                      src={
                                        itemData?.rating == "1"
                                          ? TerribleImpressionYellowIcon
                                          : TerribleImpressionGreyIcon
                                      }
                                      alt="Terrible"
                                    />
                                    <div
                                      style={{
                                        margin: "0px",
                                        fontSize: "10px",
                                        fontWeight:
                                        itemData?.rating == "1"
                                            ? "500"
                                            : "normal",
                                        color:
                                        itemData?.rating == "1"
                                            ? "#262a44"
                                            : "#9a9fb8",
                                      }}
                                    >
                                      {"Terrible (1)"}
                                    </div>
                                  </div>
                                  <div className=" mr-3">
                                    <img
                                      src={
                                        itemData?.rating == "2"
                                          ? BadImpressionYellowIcon
                                          : BadImpressionGreyIcon
                                      }
                                      alt="bad"
                                    />
                                    <div
                                      style={{
                                        margin: "0px",
                                        fontSize: "10px",
                                        fontWeight:
                                        itemData?.rating == "2"
                                            ? "500"
                                            : "normal",
                                        color:
                                        itemData?.rating == "2"
                                            ? "#262a44"
                                            : "#9a9fb8",
                                      }}
                                    >
                                      {"Bad (2)"}
                                    </div>
                                  </div>
                                  <div className=" mr-3">
                                    <img
                                      src={
                                        itemData?.rating == "3"
                                          ? AverageImpressionYellowIcon
                                          : AverageImpressionGreyIcon
                                      }
                                      alt="confused"
                                    />
                                    <div
                                      style={{
                                        margin: "0px",
                                        fontSize: "10px",
                                        fontWeight:
                                        itemData?.rating == "3"
                                            ? "500"
                                            : "normal",
                                        color:
                                        itemData?.rating == "3"
                                            ? "#262a44"
                                            : "#9a9fb8",
                                      }}
                                    >
                                      {"Okay (3)"}
                                    </div>
                                  </div>
                                  <div className=" mr-3">
                                    <img
                                      src={
                                        itemData?.rating == "4"
                                          ? GoodImpressionYellowIcon
                                          : GoodImpressionGreyIcon
                                      }
                                      alt="good"
                                    />
                                    <div
                                      style={{
                                        margin: "0px",
                                        fontSize: "10px",
                                        fontWeight:
                                        itemData?.rating == "4"
                                            ? "500"
                                            : "normal",
                                        color:
                                        itemData?.rating == "4"
                                            ? "#262a44"
                                            : "#9a9fb8",
                                      }}
                                    >
                                      {"Good (4)"}
                                    </div>
                                  </div>
                                  <div className=" mr-3">
                                    <img
                                      src={
                                        itemData?.rating == "5"
                                          ? PerfectImpressionYellowIcon
                                          : PerfectImpressionGreyIcon
                                      }
                                      alt="perfect"
                                    />
                                    <div
                                      style={{
                                        margin: "0px",
                                        fontSize: "10px",
                                        fontWeight:
                                        itemData?.rating == "5"
                                            ? "500"
                                            : "normal",
                                        color:
                                        itemData?.rating == "5"
                                            ? "#262a44"
                                            : "#9a9fb8",
                                      }}
                                    >
                                      {"Perfect (5)"}
                                    </div>
                                  </div>
                                </div>
                          </td>
                          
                        );
                      }
                      else if (item?.value == "comment") {
                        return (
                          <td
                            className="text-left"
                            style={{ minWidth: "175px" }}
                          >
                            {itemData?.comment?itemData?.comment:"NA"}
                          </td>
                        );
                      }

                      return null;
                    })
              }
            </tr>
          );
        })}
    </>
  );
};

export default AllUserRatingTableData;

